import { render, staticRenderFns } from "./bServiceView.vue?vue&type=template&id=31bd67e9&scoped=true"
import script from "./bServiceView.vue?vue&type=script&lang=js"
export * from "./bServiceView.vue?vue&type=script&lang=js"
import style0 from "./bServiceView.vue?vue&type=style&index=0&id=31bd67e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd67e9",
  null
  
)

export default component.exports